import pick from 'lodash/pick';
import fetch from '../utils/fetch-json';

import { getFormActions } from '../utils/form-helpers';
import formConfig from './invoice-form-config';
import { CART_USER_TOKEN_IDENTIFIER } from '../cart/cart-actions';
import storage from '../utils/storage';
import { getAnalyticsTrackingInfoForPayment } from '../support-and-tracking/analytics-actions';

const { setFormFields, setErrors } = getFormActions(formConfig);

const SessionStorage = storage('sessionStorage');

export const fetchInvoice =
    (invoiceId, nonce) =>
    async ({ dispatch, getState }) => {
        const state = getState();
        const response = await fetch({
            url: `${state.baseURL}/api/public/invoice/${invoiceId}/${nonce}`,
            dispatch,
            getState,
        });
        return response.body;
    };

export const registerPromotedGiverInfo =
    (promotedGiverInfo, invoiceId, nonce) =>
    async ({ dispatch, getState }) => {
        const state = getState();
        const response = await fetch({
            url: `${state.baseURL}/api/public/invoice/${invoiceId}/promoted-giver`,
            options: {
                method: 'POST',
                body: {
                    promotedGiverInfo,
                    nonce,
                },
            },
            dispatch,
            getState,
        });
        return response.body;
    };

export function fetchOrganizationFromExternalSource(organizationNumber) {
    return ({ dispatch, getState }) => {
        if (!(organizationNumber || '').match(/^\d{9}$/)) {
            return;
        }

        const state = getState();

        return fetch({
            url: `${state.baseURL}/api/public/search/organization-register?q=${organizationNumber}`,
            dispatch,
            getState,
        })
            .then((response) => {
                const organization = response.body[0];
                const address = organization.forretningsadresse || organization.postadresse;
                dispatch(
                    setFormFields({
                        name: organization.name,
                        address1: address.adresse,
                        postalCode: address.postnummer,
                        postalPlace: address.poststed,
                    })
                );
                return Promise.resolve();
            })
            .catch(() => dispatch(setErrors({ organizationNumber: 'Fant ikke organisasjonen' })));
    };
}

export function createInvoice({
    totalAmount,
    rewardFromUserMetadata,
    consentedToPersonalizedNewsletter,
    memorialCommentId,
}) {
    return async ({ dispatch, getState }) => {
        const state = getState();
        const paymentInfo = pick(state.paymentForm, ['amount', 'rewards']);
        const invoice = pick(state.invoiceForm, [
            'address1',
            'email',
            'name',
            'sendAsEhf',
            'taxDeduction',
            'organizationNumber',
            'postalCode',
            'postalPlace',
            'projectId',
            'subprojectId',
            'resourceNumber',
            'contactPersonAtCompany',
            'giverName',
            'comment',
            'commentImageUrl',
        ]);

        const invoiceWithReference = {
            ...paymentInfo,
            ...invoice,
            yourReference: [invoice.contactPersonAtCompany, invoice.resourceNumber].filter(Boolean).join(' // '),
            amount: totalAmount,
        };

        const analyticsTrackingInfo = await getAnalyticsTrackingInfoForPayment({
            state,
            projectId: invoiceWithReference.projectId,
        });

        return fetch({
            url: `${state.baseURL}/api/public/invoice/`,
            options: {
                method: 'POST',
                body: {
                    ...invoiceWithReference,
                    rewardFromUserMetadata,
                    userTokenId: SessionStorage.get(CART_USER_TOKEN_IDENTIFIER),
                    analyticsTrackingInfo,
                    consentedToPersonalizedNewsletter,
                    memorialCommentId,
                },
            },
            dispatch,
            getState,
        });
    };
}
